import { render, staticRenderFns } from "./updateTelDialog.vue?vue&type=template&id=5f766194&scoped=true"
import script from "./updateTelDialog.vue?vue&type=script&lang=js"
export * from "./updateTelDialog.vue?vue&type=script&lang=js"
import style0 from "./updateTelDialog.vue?vue&type=style&index=0&id=5f766194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f766194",
  null
  
)

export default component.exports